export default __webpack_public_path__ + "static/media/s4_male.5a5e5e76.wav";